"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDatePickerWeekdayHeader = function ClayDatePickerWeekdayHeader(_ref) {
  var children = _ref.children,
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      weekdaysShort = _ref.weekdaysShort;
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: "date-picker-days-row date-picker-row",
    role: "presentation"
  }, weekdaysShort.map(function (_weekday, index) {
    return _react.default.Children.only(children({
      key: index,
      weekday: weekdaysShort[(index + firstDayOfWeek) % 7]
    }));
  }));
};

var _default = ClayDatePickerWeekdayHeader;
exports.default = _default;